import React from "react"
import { window, document } from 'browser-monads';
// import styled from 'styled-components'
// import he from 'he';
import { useRef } from "react"
// import { useState } from "react"
// import { useEffect } from "react"

const SITES = {
  'www': 'https://admin.startupitalia.eu',
  'startupitalia.eu': 'https://admin.startupitalia.eu',
  'impact': 'https://impact-admin.startupitalia.eu',
  'impact-admin.startupitalia.eu': 'https://impact-admin.startupitalia.eu',
  'cybersecurity': 'https://cybersecurity-admin.startupitalia.eu',
  'cybersecurity-admin.startupitalia.eu': 'https://cybersecurity-admin.startupitalia.eu',
  'ischool': 'https://ischool-admin.startupitalia.eu',
  'ischool-admin.startupitalia.eu': 'https://ischool-admin.startupitalia.eu',
  'openinnovation': 'https://openinnovation-admin.startupitalia.eu',
  'openinnovation-admin.startupitalia.eu': 'https://openinnovation-admin.startupitalia.eu',
  'smartworking': 'https://smartworking-admin.startupitalia.eu',
  'smartworking-admin.startupitalia.eu': 'https://smartworking-admin.startupitalia.eu',
  'smartmoney': 'https://smartmoney-admin.startupitalia.eu',
  'smartmoney-admin.startupitalia.eu': 'https://smartmoney-admin.startupitalia.eu',
  'sportup': 'https://sportup-admin.startupitalia.eu',
  'sportup-admin.startupitalia.eu': 'https://sportup-admin.startupitalia.eu',
  'thefoodmakers': 'https://thefoodmakers-admin.startupitalia.eu',
  'thefoodmakers-admin.startupitalia.eu': 'https://thefoodmakers-admin.startupitalia.eu',
  'thenexttech': 'https://thenexttech-admin.startupitalia.eu',
  'thenexttech-admin.startupitalia.eu': 'https://thenexttech-admin.startupitalia.eu',
  'valoreresponsabile': 'https://valoreresponsabile-admin.startupitalia.eu',
  'valoreresponsabile-admin.startupitalia.eu': 'https://valoreresponsabile-admin.startupitalia.eu',
  'life': 'https://life-admin.startupitalia.eu',
  'life-admin.startupitalia.eu': 'https://life-admin.startupitalia.eu',
  'staging': 'https://startupitalia.c.wpstage.net',
  'startupitalia.c.wpstage.net': 'https://startupitalia.c.wpstage.net',
}

// const { localStorage } = window;

// const DivEditPost = styled.div`
//   // display: none;
//   text-align: center;
//   /*width: 300px;height: fit-content;background: white;*/
//   background: white;
//   position: absolute;
//   right: 0;
//   top: 0;
//   // margin-top: 80px;
//   background-color: #ffffff;
//   height: 58px;
//   width: fit-content;
//   border-radius: 29px;
//   /*-moz-box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);
// box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);*/
//   box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.5);
//   padding-top: 6px;
//   padding-left: 10px;
//   padding-right: 10px;

//   @media only screen and (max-width: 640px) {
//     right: -80px;
//   }
// `

function EditPostButton ({
    components_name_md5,
    // title,
    // url,
    postId,
    vertical,
  }) {

  const node = useRef()
  // let _share_url = encodeURIComponent(window.location.href);
  // try {
  //   if (url && url.startsWith('/'))
  //     _share_url = encodeURIComponent(
  //       new URL(`${window.location.protocol}//${window.location.host}${url}`)
  //     );
  //   else{
  //     _share_url = encodeURIComponent(new URL(url));
  //   }
  // } catch (error) {
  // }
  // let _share_text = "";

  // const [isIWorkHere, setIsIWorkHere] = useState(false);
  // const share_text = _share_text;
  // const share_url = _share_url;

  // function decodeHTML(html) {
  //   var txt = document.createElement('textarea');
  //   txt.innerHTML = html;
  //   return txt.value;
  // };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  function getLoggedInCookie() {
    var wpCookie = document.cookie.indexOf("wp-settings-time") !== -1;

    return wpCookie ? true : false;
  }

  const domain = SITES[vertical] || "https://admin.startupitalia.eu";
  const _url =
    getLoggedInCookie() || "i-work-here" in params
      ? `${domain}/wp-admin/post.php?post=${postId}&action=edit&classic-editor`
      : null;
  return (
    <div>
      {("i-work-here" in params || getLoggedInCookie()) && (
        <div
          className="edit-post"
          style={{
            background: "white",
            width: "2rem",
            height: "2rem",
            borderRadius: "10px",
          }}
        >
          <a target={`_blank `} rel={`noopener noreferrer`} href={_url}>
            <div
              ref={node}
              role="button"
              tabIndex="0"
              id={"newmag_social_edit" + components_name_md5}
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
              }}
              alt="Share article"
            >
              <img
                className="icon_edit"
                alt="Edit article"
                src="/img/edit@2x.png"
                style={{ marginTop: "7px", width: "27px", height: "auto" }}
              />
            </div>
          </a>
        </div>
      )}
    </div>
  );
}

export default EditPostButton;
